import React from 'react';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {flexRender} from '@tanstack/react-table';

export const QueryToolHeaderRow = ({headerGroups, totalSize, onDragEnd, onResizeHover, onResizeLeave}) => (
    <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="table-head" direction="horizontal">
            {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps} className="rt-thead -header">
                    {headerGroups.map(headerGroup => (
                        <div key={headerGroup.id} className="rt-tr-group" role="rowgroup">
                            <div className="rt-tr" role="row" style={{minWidth: totalSize}}>
                                {headerGroup.headers.map(header => (
                                    <Draggable draggableId={header.id} key={header.id} index={header.index}>
                                        {(draggableProvided) => (
                                            <div
                                                ref={draggableProvided.innerRef}
                                                {...draggableProvided.draggableProps}
                                            >
                                                <div
                                                    className="rt-th"
                                                    key={header.id}
                                                    style={{
                                                        flex: `${header.getSize()} 0 auto`,
                                                        width: header.getSize(),
                                                        maxWidth: header.getSize(),
                                                    }}
                                                >
                                                    {header.isPlaceholder
                                                        ? null
                                                        : flexRender(
                                                            header.column.columnDef.header,
                                                            {
                                                                ...header.getContext(),
                                                                dragHandleProps: draggableProvided.dragHandleProps,
                                                            },
                                                        )
                                                    }
                                                    <div
                                                        onMouseDown={header.getResizeHandler()}
                                                        onTouchStart={header.getResizeHandler()}
                                                        onMouseOver={() => onResizeHover(header.column.columnDef?.data?.guid)}
                                                        onMouseLeave={onResizeLeave}
                                                        className={`resizer ${header.column.getIsResizing() ? 'isResizing' : ''}`}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                            </div>
                        </div>
                    ))}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>
    </DragDropContext>
);
